"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FlyoutBrandsBody = void 0;
var _react = _interopRequireDefault(require("react"));
var _key = require("b2b-components/utils/key");
var _Flyout = require("../../Flyout");
require("./FlyoutBrandsBody.scss");
var FlyoutBrandsBody = function FlyoutBrandsBody(_ref) {
  var brands = _ref.brands,
    closeFlyout = _ref.closeFlyout,
    onLinkClick = _ref.onLinkClick;
  if (!(brands !== null && brands !== void 0 && brands.length)) {
    return null;
  }
  var handleLinkClick = function handleLinkClick(_ref2) {
    var href = _ref2.href;
    onLinkClick(href);
    closeFlyout();
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-FlyoutBrands"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-FlyoutBrands-LinksGroups"
  }, /*#__PURE__*/_react["default"].createElement(_Flyout.Flyout.Body, null, /*#__PURE__*/_react["default"].createElement("ul", {
    className: "cds-FlyoutBrands-List"
  }, brands.map(function (brand, index) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: (0, _key.createKey)(index, brand.title)
    }, /*#__PURE__*/_react["default"].createElement(_Flyout.Flyout.LinksGroup, {
      position: index + 1,
      group: brand,
      onClick: handleLinkClick,
      className: "cds-FlyoutBrands-LinksGroup"
    }));
  })))));
};
exports.FlyoutBrandsBody = FlyoutBrandsBody;